import { render, staticRenderFns } from "./WarehouseComp.vue?vue&type=template&id=d28a600a&"
import script from "./WarehouseComp.vue?vue&type=script&lang=js&"
export * from "./WarehouseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports